import { createStore, applyMiddleware } from "redux"
import createSagaMiddleware from "redux-saga"
import axiosMiddleware from "redux-axios-middleware"
import { composeWithDevTools } from "redux-devtools-extension"
// import { logger } from "redux-logger"

import sagas from "./root-saga"
import rootReducer from "./root-reducer"
import client from "./api/axios-client"

const sagaMiddleware = createSagaMiddleware()

const middlewares = []

const options = {
  // not required, but use-full configuration option
  returnRejectedPromiseOnError: true,
  interceptors: {
    response: [
      {
        error: ({ dispatch }, error) => {
          // Response Error Interception
          const { response } = error

          if (response?.status === 401) {
            // Logout user upon receiving status 401
            dispatch({ type: "USER_LOGOUT_REQUESTED" })
          }
          return Promise.reject(error)
        },
      },
    ],
  },
}

middlewares.push(axiosMiddleware(client, options))
middlewares.push(sagaMiddleware)
// middlewares.push(logger)
//create .env for adding dependencies based on environment
// if (process.env.NODE_ENV === `development`) {
// 	middlewares.push(logger);
// }

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middlewares))
)
sagaMiddleware.run(sagas)

export default store
